// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"78":"batch-submission","909":"admin-views"}[chunkId] + "." + {"78":"fded335f","909":"09bb22d2"}[chunkId] + ".js";
};